var _rect, _path, _g, _path2, _g2, _rect2, _rect3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectedProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 316,
    height: 196,
    viewBox: "0 0 316 196",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 315,
    height: 196,
    rx: 15,
    fill: "#38879F",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5643_42831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 109,
    width: 72,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5 109.232H125.78V142.415H54.5V109.232Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5643_42831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1425 115.982C70.968 115.982 61.248 119.276 61.248 125.779C61.248 132.34 70.968 135.665 90.1425 135.665C109.313 135.665 119.028 132.371 119.028 125.869C119.028 119.308 109.313 115.982 90.1425 115.982ZM90.1425 142.415C81.327 142.415 54.498 142.415 54.498 125.779C54.498 110.947 74.8425 109.232 90.1425 109.232C98.958 109.232 125.778 109.232 125.778 125.869C125.778 140.701 105.438 142.415 90.1425 142.415Z",
    fill: "#38879F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5643_42831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 53,
    width: 49,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2441 53.002H114.034V100.786H66.2441V53.002Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5643_42831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1437 59.4279C80.5092 59.4279 72.6702 67.2624 72.6702 76.8969C72.6387 86.4999 80.4192 94.3299 90.0132 94.3659L90.1437 97.5789V94.3659C99.7737 94.3659 107.608 86.5269 107.608 76.8969C107.608 67.2624 99.7737 59.4279 90.1437 59.4279ZM90.1438 100.787H89.9998C76.8508 100.747 66.1993 90.0235 66.2443 76.8835C66.2443 63.721 76.9633 53.002 90.1438 53.002C103.32 53.002 114.034 63.721 114.034 76.897C114.034 90.073 103.32 100.787 90.1438 100.787Z",
    fill: "#38879F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 63.6406,
    width: 130,
    height: 12,
    rx: 6,
    fill: "url(#paint0_linear_5643_42831)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 86.6406,
    width: 110,
    height: 12,
    rx: 6,
    fill: "url(#paint1_linear_5643_42831)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.999 140.166C268.52 140.166 259.166 149.52 259.166 160.999C259.166 172.479 268.52 181.833 279.999 181.833C291.479 181.833 300.833 172.479 300.833 160.999C300.833 149.52 291.479 140.166 279.999 140.166ZM286.999 165.791C287.604 166.395 287.604 167.395 286.999 167.999C286.687 168.312 286.291 168.458 285.895 168.458C285.499 168.458 285.104 168.312 284.791 167.999L279.999 163.208L275.208 167.999C274.895 168.312 274.499 168.458 274.104 168.458C273.708 168.458 273.312 168.312 272.999 167.999C272.395 167.395 272.395 166.395 272.999 165.791L277.791 160.999L272.999 156.208C272.395 155.604 272.395 154.604 272.999 153.999C273.604 153.395 274.604 153.395 275.208 153.999L279.999 158.791L284.791 153.999C285.395 153.395 286.395 153.395 286.999 153.999C287.604 154.604 287.604 155.604 286.999 156.208L282.208 160.999L286.999 165.791Z",
    fill: "#E40606"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5643_42831",
    x1: 149.826,
    y1: 69.8989,
    x2: 279.895,
    y2: 69.8989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B188",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5643_42831",
    x1: 149.776,
    y1: 92.8989,
    x2: 259.834,
    y2: 92.8989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B188",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedProfile);
export default __webpack_public_path__ + "static/media/rejected-profile.740bb90c262847fd9f15c9cd7097d8b5.svg";
export { ForwardRef as ReactComponent };